import { useState } from "react"
import styled from "styled-components"

import { useGetVendorReferralTrendsQuery } from "store/api/referralsApi"

import { Spinner } from "components/common/Spinner"
import { TrendCard } from "pages/referralAgent/Dashboard/TrendCard"

import { buildVendorTrendMetrics } from "./trendsData"

const PERIODS = [7, 30, 90, 180]

const Section = styled.section`
  margin-bottom: 24px;
  padding: 24px;
  border-radius: 20px;
  background: var(--surface-2);
`

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
`

const SectionTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
`

const RangeSelect = styled.select`
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid var(--border-default);
  background: var(--surface-1);
  cursor: pointer;
  font-size: 12px;
  color: var(--text-primary);
`

const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`

// two cards per pack, so the four cards wrap 4 -> 2x2 -> 1 column without leaving a lone card
const CardsPack = styled.div`
  flex: 1 0 0;
  min-width: min(440px, 100%);
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`

const Message = styled.p`
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
`

export const ReferralTrends = () => {
  const [period, setPeriod] = useState(7)
  const { data, isFetching, isError } = useGetVendorReferralTrendsQuery(period)

  const renderCards = () => {
    if (isFetching) return <Spinner />
    if (isError || !data?.data) return <Message>Trends are unavailable right now.</Message>

    const metrics = buildVendorTrendMetrics(data.data)

    return [metrics.slice(0, 2), metrics.slice(2)].map(pack => (
      <CardsPack key={pack[0].title}>
        {pack.map(metric => (
          <TrendCard key={metric.title} metric={metric} />
        ))}
      </CardsPack>
    ))
  }

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>Trends</SectionTitle>
        <RangeSelect
          aria-label="Trends period"
          value={period}
          onChange={event => setPeriod(Number(event.target.value))}
        >
          {PERIODS.map(days => (
            <option key={days} value={days}>
              Last {days} days
            </option>
          ))}
        </RangeSelect>
      </SectionHeader>
      <CardsRow>{renderCards()}</CardsRow>
    </Section>
  )
}
